import React, { Component } from 'react'
import { Link } from 'react-router'

import classNames from './FeaturedAlbum.css'
import { shuffle } from '../../utils/array'

export default class FeaturedAlbum extends Component {
  album = shuffle(this.props.albums)[0]
  state = {
    loaded: false
  }
  componentDidMount () {
    const { getImageSource } = this.props
    this.img = new window.Image()
    this.img.onload = () => this.setState({ loaded: true })
    this.img.src = getImageSource(this.album.cover, 'd')
  }
  shouldComponentUpdate (nextProps, nextState) {
    return !this.state.loaded && nextState.loaded
  }
  componentWillUnmount () {
    this.img.src = ''
  }
  render () {
    const { getImageSource } = this.props
    const { loaded } = this.state
    const coverClass = loaded ? classNames.coverLoaded : classNames.cover
    const coverStyle = {
      backgroundImage: `url(${getImageSource(this.album.cover, 'd')})`
    }
    return (
      <div className={classNames.album}>
        <div className={coverClass} style={coverStyle} />
        <div className={classNames.title}>
          Featured Album
        </div>
        <Link to={`/album/${this.album.id}`} className={classNames.name}>
          {this.album.name}
        </Link>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/home/FeaturedAlbum.js